import gql from "graphql-tag";

export default gql`
	fragment SpecialInstruction on CremationOrderSpecialInstruction {
		ID
		Title
		Comment
		Confirmed
	}
`;